export const skillsData = [
    {
      label: "FRONT END",
      data: [
        {
          skillName: "HTML",
          percentage: "100",
        },
        {
          skillName: "CSS",
          percentage: "90",
        },
        {
          skillName: "JAVASCRIPT",
          percentage: "80",
        },
        {
          skillName:"REACT",
          percentage: "95",
        }
      ],
    },
    {
      label: "BACK END",
      data: [
        {
          skillName: "NODE JS",
          percentage: "60",
        },
        {
          skillName:"EXPRESS JS",
          percentage:"60",
        }
      ],
    },
    {
      label: "DATABASES",
      data: [
        {
          skillName: "MySQL",
          percentage: "80",
        },
        {
          skillName: "MONGO DB",
          percentage: "75",
        },
        
      ],
    },
  ];